/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* --------------------------------------------------------------------------
 * トップのフルスクリーン・スライドショーが自動再生されず1枚目で固まる問題の対策
 * --------------------------------------------------------------------------
 * Prestige は次スライドの画像を遅延読み込みする間 Flickity の autoPlay を
 * 一時停止 (pausePlayer → player.state === 'paused') し、画像の 'lazyloaded'
 * イベントを受けて再開する作り。そのイベントが発火せず 'paused' のまま
 * 固まることがある（＝スライドが切り替わらない）。
 *
 * ここでは player.state が 'paused'（＝Prestige が止めた状態）のときだけ
 * 再開する。ユーザーがスワイプして止めた場合は state が 'stopped' になるので
 * そちらには触れない。autoPlay 設定が OFF のときや画像が1枚のときも何もしない。
 * ------------------------------------------------------------------------ */
(function () {
  var CAROUSEL_SELECTOR = '.Slideshow--fullscreen .Slideshow__Carousel';

  function getFlickity() {
    if (typeof Flickity === 'undefined') return null;
    var el = document.querySelector(CAROUSEL_SELECTOR);
    return el ? Flickity.data(el) : null;
  }

  function keepPlaying() {
    var flkty = getFlickity();
    if (!flkty || !flkty.options || !flkty.options.autoPlay) return;
    if (!flkty.cells || flkty.cells.length < 2) return;
    if (flkty.player && flkty.player.state === 'paused') {
      flkty.playPlayer();
    }
  }

  function boot() {
    keepPlaying();
    setInterval(keepPlaying, 1500);
  }

  if (document.readyState !== 'loading') {
    setTimeout(boot, 600);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(boot, 600);
    });
  }
})();

/* --------------------------------------------------------------------------
 * 2026-09-20: 展開中の親リンクのクリックを抑止する処理を削除した
 * --------------------------------------------------------------------------
 * 元の目的は「中身の無い一覧ページへ遷移してしまう」ことの回避だった
 * （/pages/tea-types などが空だった頃の対策）。
 * その後 tea-types / tea-usage / tea-origins にはタイル一覧が入り、
 * コレクションの親（茶器・鉄瓶・秋津無名異 酸化 など）も実体のある
 * 遷移先を持つようになったため、抑止する理由が無くなった。
 *
 * 抑止が残っていると、PC でメニューを開いた状態では親カテゴリーを
 * クリックしても移動できない（ALLOW_NAVIGATION に入れた /blogs/ だけが例外）。
 * 実際 2026-09-20 に「Tetsubin や Akitsu Mumyoi をクリックしても移動できない」
 * という指摘があり、原因はここだった。
 *
 * 併せて、子を持つ親には子リストの先頭に「すべて見る」を出すようにしたので
 * （sections/header.liquid / sections/sidebar-menu.liquid /
 *   snippets/sidebar-menu-node.liquid）、タッチ環境で theme.js の
 * _handleTouchMenu が 1 回目のタップを食う場合でも親のページへ辿り着ける。
 * ------------------------------------------------------------------------ */


/**
 * カートドロワーのスクロール示唆（2026-09-22）
 *
 * 商品リスト（.Drawer__Main）が見切れているとき、上下に矢印を出す。
 * 押すとその方向へスクロールする。
 *
 * 設計メモ:
 *  - 矢印は <form class="Cart"> の *外* に置いてある（snippets/cart-drawer.liquid）。
 *    theme.js の _replaceContent が数量変更・商品追加のたびに `.Cart` を丸ごと
 *    差し替えるため、内側だと毎回作り直されてこのリスナーが外れる。
 *  - 同じ理由で .Drawer__Main は毎回取り直す（要素を保持しない）。
 *  - scroll はバブリングしないので、document でキャプチャして拾う。
 *  - 縦位置は実寸から計算する。フッターの高さは配送日時アプリの有無や
 *    注文メモの開閉で変わるので CSS では決め打ちできない。
 */
(function () {
  var EDGE = 8; // これ未満の余りは「端に着いた」とみなす

  function init() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;

    var up = drawer.querySelector('[data-cart-scroll-cue="up"]');
    var down = drawer.querySelector('[data-cart-scroll-cue="down"]');
    if (!up || !down) return;

    var queued = false;
    var settleTimer = 0;

    function update() {
      queued = false;
      var main = drawer.querySelector('.Drawer__Main');
      if (!main || drawer.getAttribute('aria-hidden') === 'true') {
        up.hidden = true;
        down.hidden = true;
        drawer.classList.remove('has-cart-more');
        return;
      }

      var rest = main.scrollHeight - main.clientHeight - main.scrollTop;
      var canUp = main.scrollTop > EDGE;
      var canDown = rest > EDGE;

      up.hidden = !canUp;
      down.hidden = !canDown;
      /* 下に続きがあるときだけ、フッターの上に淡いぼかしを出す。
         矢印が本文の上に浮いて見えるのを避け、「ここから下がフッター」と
         分かるようにする（2026-09-23）。 */
      drawer.classList.toggle('has-cart-more', canDown);

      if (canUp || canDown) {
        var dr = drawer.getBoundingClientRect();
        var mr = main.getBoundingClientRect();
        /* 2026-10-12（D-3 の5）: スマホで丸ボタンを商品の欄の内側に置くと、価格や数量の枠に重なった。 */
        var mobile = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
        if (mobile) {
          var size = down.offsetHeight || up.offsetHeight || 30;
          // スマホ（2026-10-13）: 上向きは見出しの帯（「カート (6)」と × の間の空き）の中、
          // 下向きは写真の列（左端）の下端、境目にまたがる位置。商品の文字にかけない
          up.style.top = Math.round(mr.top - dr.top - size - 6) + 'px';
          // 下の欄の上の余白（10px）を越えないよう、丸の下の3分の1だけを境目の下に出す（当日発送の行にかけない）
          down.style.top = Math.round(mr.bottom - dr.top - size * 2 / 3) + 'px';
        } else {
          // PC は 2026-10-12 時点の本番と同じ位置（北城さん「PC は何も触らなくてよい」）
          up.style.top = Math.round(mr.top - dr.top + 10) + 'px';
          down.style.top = Math.round(mr.bottom - dr.top - 44) + 'px';
        }
      }
    }

    /**
     * 再判定の予約。
     *
     * requestAnimationFrame 1回だけでは足りない。`.Cart` の差し替え直後に
     * MutationObserver から測ると、新しい中身の高さがまだ確定しておらず
     * 「あふれていない」と誤判定して下矢印が出ない（2026-09-22 に実測で検出。
     * 531px の中身を 503px の枠に入れた状態で下矢印が出なかった）。
     * 次フレームと、レイアウトが落ち着いた頃の2回測る。
     */
    function schedule() {
      if (!queued) {
        queued = true;
        window.requestAnimationFrame(update);
      }
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(update, 200);
    }

    function scrollBy(sign) {
      var main = drawer.querySelector('.Drawer__Main');
      if (!main) return;
      var step = Math.max(120, Math.round(main.clientHeight * 0.8));
      if (main.scrollBy) {
        main.scrollBy({ top: sign * step, behavior: 'smooth' });
      } else {
        main.scrollTop += sign * step;
      }
    }

    up.addEventListener('click', function () { scrollBy(-1); });
    down.addEventListener('click', function () { scrollBy(1); });

    // scroll はバブリングしないのでキャプチャで拾う
    document.addEventListener('scroll', schedule, true);
    window.addEventListener('resize', schedule);
    document.addEventListener('product:added', schedule);
    document.documentElement.addEventListener('cart:refresh', schedule);

    // 商品画像の読み込み完了で行の高さが変わることがある
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      var watched = null;
      var rewatch = function () {
        var main = drawer.querySelector('.Drawer__Main');
        if (main && main !== watched) {
          if (watched) ro.unobserve(watched);
          ro.observe(main);
          watched = main;
        }
        if (main && main.firstElementChild) ro.observe(main.firstElementChild);
      };
      rewatch();
      document.addEventListener('product:added', rewatch);
      document.documentElement.addEventListener('cart:refresh', rewatch);
    }

    // ドロワーの開閉と .Cart の差し替えを拾う
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(drawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * PCのヘッダーをスクロール時に縮める（2026-09-23）
 *
 * ブログ記事を読むとき、固定ヘッダーが画面の16%（1440×900で145px）を
 * 常時占めていた。読み始めたらロゴと余白を詰めて本文に場所を譲る。
 *
 * 注意: `--header-height` はドロワーの高さ計算などに使われる
 * （theme.css の `.Drawer__Content { height: calc(100% - var(--header-height)) }`）。
 * 高さを変えたら必ずこの変数も測り直すこと。元は header.liquid の
 * インラインスクリプトが読み込み時に一度だけ設定している。
 *
 * 見た目の切り替えは CSS 側で 641px 以上に限定しているので、
 * スマホではクラスが付いても何も起きない。
 */
(function () {
  var header = document.getElementById('shopify-section-header');
  if (!header) return;

  var ON = 160;   // これ以上スクロールしたら縮める
  var OFF = 80;   // ここまで戻したら元に戻す（境界での往復を防ぐ）
  var condensed = false;
  var queued = false;

  function syncVar() {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  function apply() {
    queued = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var want = condensed ? y > OFF : y > ON;
    if (want === condensed) return;
    condensed = want;
    header.classList.toggle('is-condensed', condensed);
    window.setTimeout(syncVar, 260);  // 遷移が終わってから測る
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { syncVar(); onScroll(); });
  apply();
})();
